import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet - Akut Vikaren ApS"
        description="Du har ikke tilladelse til at tilgå denne side hos Akut Vikaren ApS."
      />

      <section className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-[#f8f7f4]">
        <div className="max-w-xl w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-2xl shadow-sm border border-[#eae6dd]">
          <div className="w-16 h-16 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto text-2xl">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>

          <div className="space-y-2">
            <span className="text-xs font-bold text-red-600 uppercase tracking-widest">Fejl 403</span>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-[#041c2c] tracking-tight">
              Adgang nægtet
            </h1>
            <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
              Du har ikke rettigheder til at tilgå denne ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
            </p>
          </div>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#b39366] hover:bg-[#a18155] text-white font-semibold px-5 py-2.5 rounded text-sm shadow transition-colors"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold px-5 py-2.5 rounded text-sm transition-colors border border-slate-300"
            >
              <i className="fa-solid fa-envelope text-xs" aria-hidden="true"></i>
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="pt-6 border-t border-[#eae6dd] text-xs text-slate-500">
            <p>
              Har du spørgsmål? Ring direkte til os på{' '}
              <a href="tel:+4523964042" className="text-[#b39366] font-bold hover:underline whitespace-nowrap">
                (+45) 23 96 40 42
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
